import HeaderComponent from "../subComponent/HeaderComponent";
import React from "react";
import { Container, Typography, Link, Box } from "@mui/material";
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
    root: {
        '@media (max-width: 600px)': {
            '& .MuiTypography-h4': {
                fontSize: '1.5em', // Change h4 to h5 equivalent
            },
            '& .MuiTypography-h5': {
                fontSize: '1.25em', // Change h5 to h6 equivalent
            },
            '& .MuiTypography-h6': {
                fontSize: '1em', // Change h6 to p equivalent
                fontWeight: 'bold', // Make it bold
            },
            '& .MuiTypography-body1': {
                fontSize: '0.75em', // Change body1 to p with 0.75px
            },
            '& li': {
                fontSize: '0.9em',
            },
        },
    },
});

const RefundPolicy = () => {
    const classes = useStyles();

    return (
        <Box>
            <HeaderComponent />
            <Container>
                <Box p={3} className={classes.root}>
                    <Typography variant="h4" gutterBottom>
                        Refund Policy
                    </Typography>

                    <Typography variant="body1" gutterBottom>
                        Our Refund Policy was last updated on
                        <strong> 10th October 2024</strong>
                    </Typography>

                    <Typography variant="body1">
                        If for any reason, You experience issues when paying money to our site, We invite You to review our policy on refunds.
                    </Typography>
                    <Box p={0.5} />

                    <Typography variant="body1">
                        The following terms are applicable for any transactions made by You through Our Service.
                    </Typography>
                    <Box p={1} />

                    <Typography variant="h5" gutterBottom>
                        Interpretation and Definitions
                    </Typography>

                    <Typography variant="h6" gutterBottom>
                        Interpretation
                    </Typography>

                    <Typography variant="body1">
                        The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
                    </Typography>
                    <Box p={1} />

                    <Typography variant="h6" gutterBottom>
                        Definitions
                    </Typography>

                    <Typography variant="body1" >
                        For the purposes of this Refund Policy:
                    </Typography>

                    <ul>
                        <li>
                            <Typography variant="body1">
                                <strong>"Company"</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to <strong>INV TECHNOLOGIES</strong>.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                <strong>"Service"</strong> refers to the Website which provides the payment links for transactions related to the offered services by the company either for application or website where You can manage your data.
                            </Typography>
                        </li>
                        <li>
                            <Typography variant="body1">
                                <strong>"You"</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.
                            </Typography>
                        </li>
                    </ul>

                    <Typography variant="h5" gutterBottom>
                        Refunds
                    </Typography>

                    <Typography variant="body1" >
                        If you encounter any problems with an online transaction while paying and the transaction fails, but the amount is debited from your bank account, your refund of money will reflect in your account within 7 working days.
                    </Typography>
                    <Box p={1} />
                    <Typography variant="h5" gutterBottom>
                        Contact Us
                    </Typography>

                    <Typography variant="body1" >
                        If you have any questions about our Refund Policy, You can contact us:
                    </Typography>
                    <ul>
                        <li>
                            <Typography variant="body1">
                                By sending us an email to{" "}
                                <Link href="mailto:payments.invtechnologies@gmail.com">
                                    payments.invtechnologies@gmail.com
                                </Link>.
                            </Typography>
                        </li>
                    </ul>
                </Box>
            </Container>

        </Box>
    )
}
export default RefundPolicy;